webpackJsonp([15],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebaseConfig__ = __webpack_require__(21);
var firebase = __webpack_require__(27);
__webpack_require__(29);
__webpack_require__(28);
__webpack_require__(30);

firebase.initializeApp(__WEBPACK_IMPORTED_MODULE_0__firebaseConfig__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (firebase);

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_guard__ = __webpack_require__(23);


var Home = function Home() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 44));
};
var Calender = function Calender() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 43));
};
var Profile = function Profile() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 49));
};
var EditProfile = function EditProfile() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 48));
};
var Messages = function Messages() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 41));
};
var Search = function Search() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 39));
};
var Signup = function Signup() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 51));
};
var Signin = function Signin() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 50));
};
var Project = function Project() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 46));
};
var newProject = function newProject() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 40));
};
var projPage = function projPage() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 47));
};
var libPage = function libPage() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 45));
};


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/projects',
    name: 'Projects',
    component: Project,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/library',
    name: 'Library',
    component: libPage,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/calender',
    name: 'Calender',
    component: Calender,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/profile/:id',
    name: 'Profile',
    component: Profile,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/project/:id',
    name: 'Project',
    component: projPage,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/editprofile',
    name: 'EditProfile',
    component: EditProfile,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/messages',
    name: 'Messages',
    component: Messages,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/search',
    name: 'Search',
    component: Search,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/signup',
    name: 'Signup',
    component: Signup
  }, {
    path: '/newProject',
    name: 'AddProject',
    component: newProject,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/signin',
    name: 'Signin',
    component: Signin
  }],
  mode: 'history'
}));

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__project__ = __webpack_require__(24);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    shared: __WEBPACK_IMPORTED_MODULE_3__shared__["a" /* default */],
    project: __WEBPACK_IMPORTED_MODULE_4__project__["a" /* default */]
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiKey: 'AIzaSyCsUdvFP1yYx80TtAxDCCHHEW_KcowkNjM',
  authDomain: 'insider-53ef7.firebaseapp.com',
  databaseURL: 'https://insider-53ef7.firebaseio.com',
  projectId: 'insider-53ef7',
  storageBucket: 'insider-53ef7.appspot.com',
  messagingSenderId: '1095653283156'
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuefire__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Firebase_FirebaseInit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_select_image__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_select_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_select_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_ctk_date_time_picker__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_ctk_date_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_ctk_date_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



var App = function App() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 33));
};
// import * as firebase from 'firebase'




var AlertCmp = function AlertCmp() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 34));
};
var firestore = __WEBPACK_IMPORTED_MODULE_3__Firebase_FirebaseInit__["a" /* default */].firestore();
var settings = { timestampsInSnapshots: true };
firestore.settings(settings);


__webpack_require__(9);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('vue-ctk-date-time-picker', __WEBPACK_IMPORTED_MODULE_7_vue_ctk_date_time_picker___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuefire__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_select_image___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: '#607FB0',
    secondary: '#0277BD',
    accent: '#FF5722',
    alerts: '#f44336',
    contacts: '#F44336',
    warning: '#F9A825',
    info: '#26A69A',
    deliverable: '#e9652a',
    success: '#7986CB',
    events: '#0277bd',
    todo: '#e4ba4d',
    chat: '#7986cb'
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-alert', AlertCmp);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* store */],
  template: '<App/>',
  components: { App: App },
  created: function created() {
    var _this = this;

    // firebase.initializeApp({
    //   apiKey: 'AIzaSyCsUdvFP1yYx80TtAxDCCHHEW_KcowkNjM',
    //   authDomain: 'insider-53ef7.firebaseapp.com',
    //   databaseURL: 'https://insider-53ef7.firebaseio.com',
    //   projectId: 'insider-53ef7',
    //   storageBucket: 'insider-53ef7.appspot.com',
    //   messagingSenderId: '1095653283156'
    // })
    __WEBPACK_IMPORTED_MODULE_3__Firebase_FirebaseInit__["a" /* default */].auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.$store.dispatch('autoSignIn', user);
      }
    });
    // const messaging = firebase.messaging()
    // messaging.usePublicVapidKey('BDT33YYrgkjCFGp7F4JIp_lcQBgU9C43nstL2E5jjUkqmkfGArM4qsGXhqg0pXISLQji_Wv4Ky2ijJdc23wjE_Y')

    // messaging.requestPermission()
    // .then(() => {
    //   messaging.getToken().then(token => {
    //     console.log(`The token is ${token}`)
    //     // Store the token in the firebase db
    //   })
    // }).catch(err => {
    //   console.log(err)
    // })
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user) {
    next();
  } else {
    next('/signin');
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index_js__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    project: null
  },
  mutations: {
    setProject: function setProject(state, payload) {
      state.project = payload;
      __WEBPACK_IMPORTED_MODULE_1__router_index_js__["a" /* default */].push('/project/' + payload.id);
    },
    setProjectTime1: function setProjectTime1(state, payload) {
      state.project = payload;
      __WEBPACK_IMPORTED_MODULE_1__router_index_js__["a" /* default */].push('/projects');
    }
  },
  actions: {
    editProject: function editProject(_ref, _ref2) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;
      var project = _ref2.project,
          file = _ref2.file;

      commit('setLoading', true);
      commit('clearError');
    },
    updateProject: function updateProject(_ref3, payload) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(payload.id).set({ id: payload.id, title: payload.title, files: payload.files, image: payload.image, description: payload.description, startDate: payload.startDate, endDate: payload.endDate, members: payload.members, creator: payload.creator }).then(function (response) {
        commit('setProject', payload);
        commit('setLoading', false);
      });
    },
    newFile: function newFile(_ref4, payload) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit;

      commit('setLoading', true);
      commit('clearError');
      if (payload[1] != null) {
        var path = 'project_file/' + payload[2] + Math.random() * 1000;
        var storageref = __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].storage().ref(path);
        storageref.put(payload[1]).then(function (response) {
          storageref.getDownloadURL().then(function (url) {
            var taggy = payload[5];
            if (payload[5] === []) {
              taggy = undefined;
            }
            var files = {
              fileURL: url,
              title: payload[3],
              tags: taggy
            };
            if (payload[2] === 0) {
              __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(payload[4]).collection('files').add({ file: files });
            }
            if (payload[2] !== 0) {
              payload[0].push(files);
              __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(payload[2]).update({ files: payload[0] });
            }
          }).catch(function (error) {
            console.log(error);
            return;
          });
        });
      }
    },
    UpdateMembers: function UpdateMembers(_ref5, payload) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit;

      commit('setLoading', true);
      commit('clearError');
      var id = payload[payload.length - 1];
      var length = payload[payload.length - 2];
      var newMembers = [];
      for (var i = 0; i < payload.length - 2; i++) {
        newMembers.push(payload[i]);
      }
      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(id).update({ members: newMembers });
      for (var j = newMembers.length - 1; j > newMembers.length - (length + 1); j--) {
        __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(newMembers[j]).collection('projects').add({
          projectID: id
        });
      }
    },
    readProjectNotification: function readProjectNotification(_ref6, _ref7) {
      var commit = _ref6.commit;
      var project = _ref7.project,
          user = _ref7.user,
          notification = _ref7.notification;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(project).collection('notifications').doc(notification).update({
        'read': __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore.FieldValue.arrayUnion(user)
      });
    },
    CreateItem: function CreateItem(_ref8, payload) {
      var dispatch = _ref8.dispatch,
          commit = _ref8.commit;

      commit('setLoading', true);
      commit('clearError');
      if (payload.type === 'meeting') {
        payload.members.push(payload.creator);
        payload.rsvp.push(payload.creator);
        __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(payload.projectID).collection(payload.type).add({
          title: payload.title,
          description: payload.description,
          startDate: payload.startDate,
          startTime: payload.startTime,
          members: payload.members,
          creator: payload.creator,
          repeat: payload.repeat,
          rsvp: payload.rsvp,
          no: payload.no,
          location: payload.location,
          callin: payload.callin
        }).then(function (docRef) {
          __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(payload.projectID).collection('notifications').add({
            message: 'A new ' + payload.type + ' has been created: ' + payload.title + '.',
            creator: payload.creator,
            type: payload.type,
            timestamp: new Date().getTime(),
            eventID: docRef.id,
            read: [payload.creator]
          });
        });

        // if (payload.repeat !== '') {
        //   if (this.project.endDate === 0) {

        //   }
        //   if (this.project.endDate !== 0) {
        //     var stop = this.project.endDate
        //     if (payload.repeat === 'day') {
        //       stop
        //     }
        //     if (payload.repeat === 'week') {
        //     }
        //     if (payload.repeat === 'month') {
        //       var payload2 = payload
        //       if (payload2.endDate.substring(5, 7) === '12') {
        //         payload2.endDate = Number(payload.endDate.substring(0, 4)) + '-01' + payload.endDate.substring(7)
        //         console.log(payload2.endDate)
        //       }
        //     }
        //     if (payload.repeat === 'year') {
        //     }
        //   }
        // }
      }
      if (payload.type === 'todo') {
        if (payload.members === []) {
          payload.members.push(payload.creator);
        }
        __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(payload.projectID).collection(payload.type).add({
          title: payload.title,
          description: payload.description,
          startDate: payload.startDate,
          startTime: payload.startTime,
          members: payload.members,
          creator: payload.creator,
          finish: false
        }).then(function (docRef) {
          __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(payload.projectID).collection('notifications').add({
            message: 'A new ' + payload.type + ' has been created: ' + payload.title + '.',
            creator: payload.creator,
            type: payload.type,
            timestamp: new Date().getTime(),
            eventID: docRef.id,
            read: [payload.creator]
          });
        });
      }
    },
    addContactProject: function addContactProject(_ref9, _ref10) {
      var commit = _ref9.commit,
          state = _ref9.state;
      var payload = _ref10.payload,
          memberID = _ref10.memberID;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(this.project.id).set({
        members: __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(this.project.id).collection('members').push(payload.contactID)
      });
    },
    deleteMember: function deleteMember(_ref11, _ref12) {
      var commit = _ref11.commit;
      var account = _ref12.account,
          member = _ref12.member;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(this.project.id).collection('members').doc(member).delete();
    },
    CreateProject: function CreateProject(_ref13, payload) {
      var dispatch = _ref13.dispatch,
          commit = _ref13.commit;

      commit('setLoading', true);
      commit('clearError');
      var images = ['/static/img/images/proj_image1.jpg', '/static/img/images/proj_image2.jpg', '/static/img/images/proj_image3.jpg', '/static/img/images/proj_image4.jpg', '/static/img/images/proj_image5.jpg', '/static/img/images/proj_image6.jpg', '/static/img/images/proj_image7.jpg'];
      var theImage = images[Math.floor(Math.random() * images.length)];
      payload.members.push(payload.creator.id);
      payload.image = theImage;
      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').add({
        title: payload.title,
        description: payload.description,
        startDate: payload.startDate,
        endDate: payload.endDate,
        members: payload.members,
        creator: payload.creator,
        image: theImage,
        files: payload.files
      }).then(function (docRef) {
        console.log('sever 2:' + docRef.id);
        __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(docRef.id).update({
          id: docRef.id
        });
        for (var i = 0; i < payload.members.length; i++) {
          __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(payload.members[i]).collection('projects').add({
            projectID: docRef.id
          });
        }
        commit('setProjectTime1', payload);
      });
    }
  },
  getters: {
    project: function project(state) {
      return state.project;
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: false,
    error: null
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    }
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    },
    setError: function setError(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setError', payload);
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__ = __webpack_require__(2);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null,
    currProj: null
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setProj: function setProj(state, payload) {
      state.currProj = payload;
    },
    setURL: function setURL(state, payload) {
      state.user.photoURL = payload;
    }
  },
  actions: {
    editProfile: function editProfile(_ref, _ref2) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;
      var user = _ref2.user,
          file = _ref2.file;

      commit('setLoading', true);
      commit('clearError');
      if (file != null) {
        var path = 'profile_photos/' + user.id;
        var storageref = __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].storage().ref(path);
        storageref.put(file).then(function (response) {
          storageref.getDownloadURL().then(function (url) {
            user.photoURL = url;
            dispatch('updateUser1', user);
          }).catch(function (error) {
            console.log(error);
            return;
          });
        });
      } else {
        dispatch('updateUser1', user);
      }
    },
    Project: function Project(_ref3, payload) {
      var commit = _ref3.commit,
          state = _ref3.state;

      state.currProj = payload;
    },
    addProject: function addProject(_ref4, _ref5) {
      var commit = _ref4.commit;
      var user = _ref5.user,
          id = _ref5.id;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(user).collection('projects').add({ projectID: id });
      this.currProj = id;
    },
    updateUser1: function updateUser1(_ref6, payload) {
      var commit = _ref6.commit;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(payload.id).set({ id: payload.id, name: payload.name, email: payload.email, photoURL: payload.photoURL, bio: payload.bio, title: payload.title, organization: payload.organization }).then(function (response) {
        commit('setUser', payload);
        commit('setLoading', false);
      });
    },
    updateUser: function updateUser(_ref7, payload) {
      var commit = _ref7.commit;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(payload.id).set({ id: payload.id, name: payload.name, projects: payload.projects, email: payload.email, photoURL: payload.photoURL, bio: payload.bio, title: payload.title, organization: payload.organization }).then(function (response) {
        commit('setUser', payload);
        commit('setLoading', false);
      });
    },
    sendNotification: function sendNotification(_ref8, payload) {
      var commit = _ref8.commit;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(payload.receiverID).collection('notifications').add({
        message: payload.message,
        senderID: payload.senderID,
        senderName: payload.senderName,
        receiverID: payload.receiverID,
        receiverName: payload.receiverName,
        read: payload.read,
        accepted: payload.accepted,
        timestamp: payload.timestamp,
        type: payload.type
      });
    },
    readNotification: function readNotification(_ref9, _ref10) {
      var commit = _ref9.commit;
      var user = _ref10.user,
          notification = _ref10.notification;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(user).collection('notifications').doc(notification).update({
        'read': true
      });
    },
    updateNotification: function updateNotification(_ref11, payload) {
      var commit = _ref11.commit;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(payload.receiverID).collection('notifications').doc(payload.id).set({
        message: payload.message,
        senderID: payload.senderID,
        senderName: payload.senderName,
        receiverID: payload.receiverID,
        receiverName: payload.receiverName,
        read: payload.read,
        accepted: payload.accepted,
        timestamp: payload.timestamp,
        type: payload.type
      });
    },
    addContact: function addContact(_ref12, _ref13) {
      var commit = _ref12.commit,
          state = _ref12.state;
      var payload = _ref13.payload,
          userID = _ref13.userID;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(userID).collection('contacts').doc(payload.contactID).set({
        contactID: payload.contactID,
        contactName: payload.contactName,
        accepted: payload.accepted,
        timestamp: payload.timestamp
      });
    },
    deleteContact: function deleteContact(_ref14, _ref15) {
      var commit = _ref14.commit;
      var account = _ref15.account,
          contact = _ref15.contact;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(account).collection('contacts').doc(contact).delete();
    },
    signUserUp: function signUserUp(_ref16, payload) {
      var dispatch = _ref16.dispatch,
          commit = _ref16.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].auth().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.user.uid,
          name: null,
          email: user.user.email,
          photoURL: 'https://www.google.com/url?sa=i&rct=j&q=&esrc=s&source=images&cd=&cad=rja&uact=8&ved=2ahUKEwi9wMD3i67cAhWPJXwKHRyoA44QjRx6BAgBEAU&url=http%3A%2F%2Fbungostraydogs.wikia.com%2Fwiki%2FFile%3AProfile-icon-9.png&psig=AOvVaw2ekzAQG2fddSTWLQQ2NxGD&ust=1532190328570451',
          bio: null,
          title: null,
          organization: null,
          projects: []
        };
        var storageref = __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].storage().ref('profile_photos/default.png');
        storageref.getDownloadURL().then(function (url) {
          newUser.photoURL = url;
          dispatch('updateUser', newUser);
        }).catch(function (error) {
          console.log(error);
          return;
        });
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserIn: function signUserIn(_ref17, payload) {
      var commit = _ref17.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].auth().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(user.user.uid).get().then(function (doc) {
          if (doc.exists) {
            commit('setUser', doc.data());
          } else {
            console.log('hello from the other side');
            return;
          }
        });
        // const newUser = {
        //   id: user.uid,
        //   name: user.displayName,
        //   email: user.email,
        //   photoURL: user.photoURL,
        //   bio: ''
        // }
        // commit('setUser', newUser)
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserInGoogle: function signUserInGoogle(_ref18) {
      var commit = _ref18.commit,
          dispatch = _ref18.dispatch;

      commit('setLoading', true);
      commit('clearError');
      var provider = new __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].auth.GoogleAuthProvider();
      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].auth().signInWithPopup(provider).then(function (user) {
        commit('setLoading', false);
        if (user.additionalUserInfo.isNewUser) {
          var newUser = {
            id: user.user.uid,
            name: user.user.displayName,
            email: user.user.email,
            photoURL: user.user.photoURL,
            bio: null,
            title: null,
            organization: null,
            projects: []
          };
          dispatch('updateUser', newUser);
        } else {
          __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(user.user.uid).get().then(function (doc) {
            if (doc.exists) {
              commit('setUser', doc.data());
            } else {
              console.log('hello from the other side');
              return;
            }
          });
        }
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },

    // signUserInFacebook ({commit}) {
    //   commit('setLoading', true)
    //   commit('clearError')
    //   firebase.auth().signInWithPopup(new firebase.auth.FacebookAuthProvider())
    //     .then(
    //       user => {
    //         commit('setLoading', false)
    //         const newUser = {
    //           id: user.uid,
    //           name: user.displayName,
    //           email: user.email,
    //           photoUrl: user.photoURL
    //         }
    //         commit('setUser', newUser)
    //       }
    //     )
    //     .catch(
    //       error => {
    //         commit('setLoading', false)
    //         commit('setError', error)
    //         console.log(error)
    //       }
    //     )
    // },
    // signUserInGithub ({commit}) {
    //   commit('setLoading', true)
    //   commit('clearError')
    //   firebase.auth().signInWithPopup(new firebase.auth.GithubAuthProvider())
    //     .then(
    //       user => {
    //         commit('setLoading', false)
    //         const newUser = {
    //           id: user.uid,
    //           name: user.displayName,
    //           email: user.email,
    //           photoUrl: user.photoURL
    //         }
    //         commit('setUser', newUser)
    //       }
    //     )
    //     .catch(
    //       error => {
    //         commit('setLoading', false)
    //         commit('setError', error)
    //         console.log(error)
    //       }
    //     )
    // },
    // signUserInTwitter ({commit}) {
    //   commit('setLoading', true)
    //   commit('clearError')
    //   firebase.auth().signInWithPopup(new firebase.auth.TwitterAuthProvider())
    //     .then(
    //       user => {
    //         commit('setLoading', false)
    //         const newUser = {
    //           id: user.uid,
    //           name: user.displayName,
    //           email: user.email,
    //           photoUrl: user.photoURL
    //         }
    //         commit('setUser', newUser)
    //       }
    //     )
    //     .catch(
    //       error => {
    //         commit('setLoading', false)
    //         commit('setError', error)
    //         console.log(error)
    //       }
    //     )
    // },
    autoSignIn: function autoSignIn(_ref19, payload) {
      var commit = _ref19.commit;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(payload.uid).get().then(function (doc) {
        if (doc.exists) {
          commit('setUser', doc.data());
        } else {
          return;
        }
      });
    },
    resetPasswordWithEmail: function resetPasswordWithEmail(_ref20, payload) {
      var commit = _ref20.commit;
      var email = payload.email;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].auth().sendPasswordResetEmail(email).then(function () {
        commit('setLoading', false);
        console.log('Email Sent');
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    logout: function logout(_ref21) {
      var commit = _ref21.commit;

      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].auth().signOut();
      commit('setUser', null);
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    },
    proj: function proj(state) {
      return state.currProj;
    }
  }
});

/***/ })
],[22]);


// WEBPACK FOOTER //
// static/js/app.5a0fb70c7361f2124c51.js